import { HeaderPrimary } from './view';

export default HeaderPrimary;
